import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { announcementsAPI } from '../services/api';
import { playSound } from '../utils/notificationSound';
import { Announcement } from '../types';
import { showCustomAlert } from './CustomAlert';
import './AnnouncementPopup.css';

interface AnnouncementPopupProps {
  announcement: Announcement;
  onAcknowledge: () => void;
}

const AnnouncementPopup: React.FC<AnnouncementPopupProps> = ({ announcement, onAcknowledge }) => {
  const [acknowledging, setAcknowledging] = useState(false);

  // Play sound once when popup is shown
  React.useEffect(() => {
    playSound('announcement');
  }, []);

  const handleAcknowledge = async () => {
    setAcknowledging(true);
    try {
      await announcementsAPI.acknowledge(announcement._id);
      // Call onAcknowledge callback which will refresh the announcement status
      onAcknowledge();
    } catch (err: any) {
      console.error('Error acknowledging announcement:', err);
      showCustomAlert.error(err.response?.data?.message || 'Greška pri potvrđivanju obaveštenja');
      setAcknowledging(false);
    }
  };

  return (
    <div className="announcement-popup-overlay">
      <div className="announcement-popup-container">
        <div className="announcement-popup-content">
          <div className="announcement-header">
            <div className="announcement-icon">
              <i className="pi pi-bell" />
            </div>
            <h2 className="announcement-title">{announcement.title}</h2>
          </div>
          
          <div className="announcement-message">
            {announcement.message}
          </div>
          
          <div className="announcement-footer">
            <div className="announcement-author">
              <i className="pi pi-user" />
              <span>Obaveštenje od: {announcement.createdBy.firstName} {announcement.createdBy.lastName}</span>
            </div>
            <Button
              label="Razumem"
              icon="pi pi-check"
              onClick={handleAcknowledge}
              loading={acknowledging}
              className="announcement-acknowledge-btn"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementPopup;

